import _taggedTemplateLiteral from "/home/bodiometer/bodiometer_website_test/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject49() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  margin-right: auto;\n  width: 98%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 3rem;\n\n  filter: ", ";\n\n  &.hide {\n    visibility: hidden;\n  }\n\n  &.show {\n    visibility: visible;\n  }\n"]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  height: 3px;\n  left: 0;\n  margin-left: auto;\n  margin-right: auto;\n  position: absolute;\n  right: 0;\n  width: 100%;\n"]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  left: 0;\n  position: absolute;\n  transition: all 0.2s ease;\n\n  &.vertical {\n    align-items: flex-start;\n    height: 100%;\n    justify-content: flex-start;\n    width: 100%;\n  }\n"]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  display: flex;\n  justify-content: center;\n  overflow-y: ", ";\n  overflow-x: hidden;\n  overscroll-behavior: contain;\n  position: relative;\n  scroll-behavior: smooth;\n  scrollbar-color: ", " default;\n  scrollbar-width: thin;\n  width: 100%;\n  padding: ", ";\n\n  &::-webkit-scrollbar {\n    width: 0.5em;\n    height: 0;\n  }\n\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    outline: 1px solid ", ";\n  }\n\n  &.horizontal {\n    height: 6rem;\n  }\n"]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  /* cannot remove this */\n  height: 100%;\n  outline: 0;\n  overflow: hidden;\n  position: relative;\n  user-select: none;\n  width: 100%;\n\n  ", ";\n\n  &.horizontal {\n    justify-content: flex-start;\n  }\n\n  &.js-focus-visible :focus:not(.focus-visible) {\n    outline: none;\n  }\n\n  &.js-focus-visible .focus-visible {\n    outline: 2px solid #528deb;\n  }\n"]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: ", ";\n  ", ";\n\n  &.left {\n    justify-content: ", ";\n    order: ", ";\n  }\n\n  &.right {\n    ", ";\n  }\n"]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n  visibility: hidden;\n\n  ", "\n\n  ", "\n\n  \n\n  &.visible {\n    visibility: visible;\n    animation: ", " 0.25s ease-in;\n  }\n"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  width: 10%;\n\n  &.left {\n    order: 2;\n  }\n\n  &.right {\n    order: 1;\n  }\n\n  &::after {\n    background: ", ";\n    content: '';\n    display: block;\n    height: 100%;\n    left: 0;\n    margin-left: auto;\n    margin-right: auto;\n    position: absolute;\n    right: 0;\n    width: 3px;\n    z-index: 0;\n  }\n"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  visibility: hidden;\n  width: 100%;\n  align-items: stretch;\n\n  &.left {\n    margin-right: auto;\n  }\n  &.right {\n    margin-left: auto;\n  }\n\n  &.visible {\n    visibility: visible;\n  }\n"]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    visibility: hidden;\n  }\n  to {\n    opacity: 1;\n    visibility: visible;\n  }\n"]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 1em;\n  outline: 0;\n"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  visibility: hidden;\n\n  &.vertical {\n    margin-bottom: 2rem;\n    width: 100%;\n  }\n\n  &.visible {\n    visibility: visible;\n  }\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 1em;\n  width: 100%;\n  &.vertical {\n    flex-direction: column;\n  }\n  &.horizontal {\n    flex-direction: row;\n  }\n"]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  animation: ", " 0.25s ease-in;\n\n  &.horizontal {\n    min-width: 400px;\n  }\n\n  &.vertical {\n    width: calc(100% - 5em);\n    margin-left: auto;\n    flex-direction: column;\n  }\n"]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  &.vertical {\n    margin-bottom: 1em;\n  }\n\n  &.horizontal {\n    position: absolute;\n    bottom: 2em;\n  }\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  height: 1em;\n  width: 1em;\n\n  &.active {\n    animation: ", " 0.1s ease-in;\n    transform: scale(1.4);\n\n    &::after {\n      background: ", ";\n      border-radius: 50%;\n      content: '';\n      display: block;\n      height: 0.75em;\n      left: 50%;\n      position: absolute;\n      right: 0;\n      top: 50%;\n      transform: translateY(-50%) translateX(-50%);\n      width: 0.75em;\n      z-index: -1;\n    }\n  }\n\n  &.in-active {\n    animation: ", " 0.1s ease-in;\n    transform: scale(1);\n  }\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  /* height: 100%; */\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 5em;\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: scale(1.4);\n  }\n  to {\n    transform: scale(1);\n  }\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(1.4);\n  }\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  border: 1px solid transparent;\n  display: flex;\n  justify-content: center;\n  position: relative;\n\n  &.vertical {\n    justify-content: flex-start;\n  }\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 0.2rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  overflow: hidden;\n  padding: 0.25rem;\n  visibility: ", ";\n  text-align: ", ";\n\n  &.active {\n    background: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  color: #a3a3a3;\n  left: 0;\n  margin-left: auto;\n  margin-right: auto;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: 50%;\n  transform: translateY(-50%);\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  /* position: absolute; */\n  bottom: -1em;\n  left: 0;\n  right: 0;\n  /* margin-left: auto; */\n  margin-right: auto;\n  width: ", ";\n  /* min-height: 100px; */\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  border-radius: 6px;\n  padding-bottom: 0.5em;\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  max-width: 100%;\n  max-height: 100%;\n  margin-left: auto;\n  margin-right: auto;\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  flex: 4;\n  justify-self: center;\n  margin-left: auto;\n  margin-right: auto;\n  max-height: 100%;\n  max-width: 100%;\n  object-fit: contain;\n  visibility: ", ";\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  align-items: center;\n  align-self: center;\n  background: ", ";\n  border-radius: 4px;\n  flex-direction: row;\n  height: 0;\n  padding: 0.5em;\n  pointer-events: ", ";\n  position: relative;\n  text-align: center;\n  width: 100%;\n\n  ", "\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  height: 1em;\n  justify-content: center;\n  margin-left: 0.2em;\n  margin-top: 0.2em;\n  width: 1em;\n  ", ";\n\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n        animation-play-state: paused;\n        width: ", "px;\n      "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    width: ", "px;\n  }\n  100% {\n    width: ", "px;\n  }  \n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n        animation: ", " ", "ms ease-in;\n        animation-play-state: running;\n      "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  bottom: -0.75em;\n  display: block;\n  height: 3px;\n  left: 0;\n  position: absolute;\n\n  ", "\n\n  svg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  align-self: flex-end;\n  background: #f5f5f5;\n  border-radius: 4px;\n  cursor: pointer;\n  display: ", ";\n  font-size: 0.75rem;\n  justify-self: flex-end;\n  margin-bottom: 0.5em;\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n  margin-top: auto;\n  padding: 0.1em 0.5em;\n\n  &:hover {\n    background: ", ";\n    color: #fff;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  font-size: 0.8rem;\n  margin: 0 auto;\n  margin-bottom: 0.5em;\n  ", "\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-color: ", " default;\n  scrollbar-width: thin;\n  transition: max-height 150ms linear;\n  width: 97%;\n  padding: 0.2em 0.2em;\n\n  &.show-less {\n    max-height: 50px;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      width: 0;\n    }\n    overflow: hidden;\n  }\n\n  &::-webkit-scrollbar {\n    width: 0.3em;\n  }\n\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    outline: 1px solid ", ";\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 0.85rem;\n  font-weight: 400;\n  margin: 0;\n  touch-action: none;\n  width: 100%;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0;\n  margin-top: 0.5em;\n  padding-left: 0.5em;\n  &.active {\n    color: ", ";\n  }\n  text-align: left;\n  width: 95%;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.85rem;\n  font-weight: 600;\n  margin: 0;\n  padding-left: 0.5rem;\n  text-align: left;\n  width: 97%;\n  color: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  background: ", ";\n  border-radius: 4px;\n  display: flex;\n  filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.2));\n  flex-direction: column;\n  justify-content: flex-start;\n  line-height: 1.5em;\n  margin: ", ";\n  position: relative;\n  text-align: left;\n  width: 100%;\n\n  &:focus {\n    outline: 1px solid ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  height: 2em;\n  justify-content: center;\n  margin-left: 0.5em;\n  width: 2em;\n  outline: 0;\n  color: #fff;\n\n  svg {\n    width: 80%;\n    height: 80%;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  visibility: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border-radius: 50%;\n  border: 0;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.25));\n  height: 2em;\n  justify-content: center;\n  margin: 0 0.2em;\n  padding: 0;\n  transition: all 0.1s ease-in;\n  width: 2em;\n\n  transform: ", ";\n\n  &:active {\n    filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.25));\n    transform: ", " scale(0.9);\n  }\n\n  svg {\n    width: 80%;\n    height: 80%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.1em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: rgba(229, 229, 229, 0.85);\n  border-radius: 25px;\n  display: flex;\n  list-style: none;\n  padding: 0.25em 0.25em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { nanoid as e } from "nanoid";
import t, { useState as n, useMemo as r, forwardRef as i, useContext as o, createContext as a, createElement as s, Fragment as l, useRef as c, useEffect as u, useCallback as d, useLayoutEffect as f } from "react";
import m from "react-dom";
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;

function p(e, t, n) {
  return e(n = {
    path: t,
    exports: {},
    require: function require(e, t) {
      return function () {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
      }(null == t && n.path);
    }
  }, n.exports), n.exports;
}

p(function (e, t) {
  !function () {
    function e(e) {
      var t = !0,
          n = !1,
          r = null,
          i = {
        text: !0,
        search: !0,
        url: !0,
        tel: !0,
        email: !0,
        password: !0,
        number: !0,
        date: !0,
        month: !0,
        week: !0,
        time: !0,
        datetime: !0,
        "datetime-local": !0
      };

      function o(e) {
        return !!(e && e !== document && "HTML" !== e.nodeName && "BODY" !== e.nodeName && "classList" in e && "contains" in e.classList);
      }

      function a(e) {
        var t = e.type,
            n = e.tagName;
        return !("INPUT" !== n || !i[t] || e.readOnly) || "TEXTAREA" === n && !e.readOnly || !!e.isContentEditable;
      }

      function s(e) {
        e.classList.contains("focus-visible") || (e.classList.add("focus-visible"), e.setAttribute("data-focus-visible-added", ""));
      }

      function l(e) {
        e.hasAttribute("data-focus-visible-added") && (e.classList.remove("focus-visible"), e.removeAttribute("data-focus-visible-added"));
      }

      function c(n) {
        n.metaKey || n.altKey || n.ctrlKey || (o(e.activeElement) && s(e.activeElement), t = !0);
      }

      function u(e) {
        t = !1;
      }

      function d(e) {
        o(e.target) && (t || a(e.target)) && s(e.target);
      }

      function f(e) {
        o(e.target) && (e.target.classList.contains("focus-visible") || e.target.hasAttribute("data-focus-visible-added")) && (n = !0, window.clearTimeout(r), r = window.setTimeout(function () {
          n = !1;
        }, 100), l(e.target));
      }

      function m(e) {
        "hidden" === document.visibilityState && (n && (t = !0), p());
      }

      function p() {
        document.addEventListener("mousemove", v), document.addEventListener("mousedown", v), document.addEventListener("mouseup", v), document.addEventListener("pointermove", v), document.addEventListener("pointerdown", v), document.addEventListener("pointerup", v), document.addEventListener("touchmove", v), document.addEventListener("touchstart", v), document.addEventListener("touchend", v);
      }

      function h() {
        document.removeEventListener("mousemove", v), document.removeEventListener("mousedown", v), document.removeEventListener("mouseup", v), document.removeEventListener("pointermove", v), document.removeEventListener("pointerdown", v), document.removeEventListener("pointerup", v), document.removeEventListener("touchmove", v), document.removeEventListener("touchstart", v), document.removeEventListener("touchend", v);
      }

      function v(e) {
        e.target.nodeName && "html" === e.target.nodeName.toLowerCase() || (t = !1, h());
      }

      document.addEventListener("keydown", c, !0), document.addEventListener("mousedown", u, !0), document.addEventListener("pointerdown", u, !0), document.addEventListener("touchstart", u, !0), document.addEventListener("visibilitychange", m, !0), p(), e.addEventListener("focus", d, !0), e.addEventListener("blur", f, !0), e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && e.host ? e.host.setAttribute("data-js-focus-visible", "") : e.nodeType === Node.DOCUMENT_NODE && (document.documentElement.classList.add("js-focus-visible"), document.documentElement.setAttribute("data-js-focus-visible", ""));
    }

    if ("undefined" != typeof window && "undefined" != typeof document) {
      var t;
      window.applyFocusVisiblePolyfill = e;

      try {
        t = new CustomEvent("focus-visible-polyfill-ready");
      } catch (e) {
        (t = document.createEvent("CustomEvent")).initCustomEvent("focus-visible-polyfill-ready", !1, !1, {});
      }

      window.dispatchEvent(t);
    }

    "undefined" != typeof document && e(document);
  }();
});

var h = function h(e, t) {
  var i = n(0),
      o = i[0],
      a = i[1];
  return [o, r(function () {
    return function (n, r) {
      var i = n.clientWidth,
          o = n.scrollLeft,
          s = n.scrollTop,
          l = n.clientHeight,
          c = r.timelinePointOffset,
          u = r.timelinePointWidth,
          d = r.timelineContentHeight,
          f = r.timelineContentOffset;
      if (c) if ("HORIZONTAL" === e && t && u) {
        var m = o + i,
            p = c + u,
            h = c - o,
            v = m - c;
        c >= o && p <= m || c < o && p > o || p > m && c < m ? (h <= t && h >= 0 || v <= t && v >= 0) && a(c - t) : a(c - t);
      } else if ("VERTICAL" === e || "VERTICAL_ALTERNATING" === e) {
        if (!f || !d) return;
        var y = s + l,
            g = f + d,
            b = f - d,
            w = !(f >= s && g <= y) || f < s && g > s || g > y && f < y;
        w && b + d < y ? a(b + Math.round(d / 2)) : w && a(b);
      }
    };
  }, [e, t])];
},
    v = function v() {
  return t.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-left"
  }, t.createElement("polyline", {
    points: "15 18 9 12 15 6"
  }));
},
    y = function y() {
  return t.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-right"
  }, t.createElement("polyline", {
    points: "9 18 15 12 9 6"
  }));
},
    g = function g() {
  return t.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevrons-left"
  }, t.createElement("polyline", {
    points: "11 17 6 12 11 7"
  }), t.createElement("polyline", {
    points: "18 17 13 12 18 7"
  }));
},
    b = function b() {
  return t.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevrons-right"
  }, t.createElement("polyline", {
    points: "13 17 18 12 13 7"
  }), t.createElement("polyline", {
    points: "6 17 11 12 6 7"
  }));
},
    w = function w() {
  return t.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, t.createElement("polygon", {
    points: "5 3 19 12 5 21 5 3"
  }));
};

p(function (e) {
  function t() {
    return e.exports = t = Object.assign || function (e) {
      for (var t = arguments, n = 1; n < arguments.length; n++) {
        var r = t[n];

        for (var i in r) {
          Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
        }
      }

      return e;
    }, t.apply(this, arguments);
  }

  e.exports = t;
});

function E(e) {
  var t = {};
  return function (n) {
    return void 0 === t[n] && (t[n] = e(n)), t[n];
  };
}

var x = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
    k = E(function (e) {
  return x.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
});

function N() {
  return (N = Object.assign || function (e) {
    for (var t = arguments, n = 1; n < arguments.length; n++) {
      var r = t[n];

      for (var i in r) {
        Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var C = function () {
  function e(e) {
    var t = this;
    this._insertTag = function (e) {
      var n;
      n = 0 === t.tags.length ? t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(e, n), t.tags.push(e);
    }, this.isSpeedy = void 0 === e.speedy ? "production" === process.env.NODE_ENV : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.before = null;
  }

  var t = e.prototype;
  return t.hydrate = function (e) {
    e.forEach(this._insertTag);
  }, t.insert = function (e) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function (e) {
      var t = document.createElement("style");
      return t.setAttribute("data-emotion", e.key), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
    }(this));
    var t = this.tags[this.tags.length - 1];

    if ("production" !== process.env.NODE_ENV) {
      var n = 64 === e.charCodeAt(0) && 105 === e.charCodeAt(1);
      n && this._alreadyInsertedOrderInsensitiveRule && console.error("You're attempting to insert the following rule:\n" + e + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !n;
    }

    if (this.isSpeedy) {
      var r = function (e) {
        if (e.sheet) return e.sheet;

        for (var t = 0; t < document.styleSheets.length; t++) {
          if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
        }
      }(t);

      try {
        r.insertRule(e, r.cssRules.length);
      } catch (t) {
        "production" !== process.env.NODE_ENV && console.error('There was a problem inserting the following rule: "' + e + '"', t);
      }
    } else t.appendChild(document.createTextNode(e));

    this.ctr++;
  }, t.flush = function () {
    this.tags.forEach(function (e) {
      return e.parentNode.removeChild(e);
    }), this.tags = [], this.ctr = 0, "production" !== process.env.NODE_ENV && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(),
    S = "-ms-",
    _ = "-moz-",
    $ = "-webkit-",
    O = "comm",
    A = "rule",
    T = "decl",
    L = Math.abs,
    I = String.fromCharCode;

function R(e) {
  return e.trim();
}

function P(e, t, n) {
  return e.replace(t, n);
}

function D(e, t) {
  return 0 | e.charCodeAt(t);
}

function j(e, t, n) {
  return e.slice(t, n);
}

function M(e) {
  return e.length;
}

function H(e) {
  return e.length;
}

function V(e, t) {
  return t.push(e), e;
}

var F = 1,
    z = 1,
    W = 0,
    U = 0,
    q = 0,
    B = "";

function Y(e, t, n, r, i, o, a) {
  return {
    value: e,
    root: t,
    parent: n,
    type: r,
    props: i,
    children: o,
    line: F,
    column: z,
    length: a,
    return: ""
  };
}

function G(e, t, n) {
  return Y(e, t.root, t.parent, n, t.props, t.children, 0);
}

function Z() {
  return q = U < W ? D(B, U++) : 0, z++, 10 === q && (z = 1, F++), q;
}

function K() {
  return D(B, U);
}

function X() {
  return U;
}

function J(e, t) {
  return j(B, e, t);
}

function Q(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;

    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;

    case 58:
      return 3;

    case 34:
    case 39:
    case 40:
    case 91:
      return 2;

    case 41:
    case 93:
      return 1;
  }

  return 0;
}

function ee(e) {
  return F = z = 1, W = M(B = e), U = 0, [];
}

function te(e) {
  return B = "", e;
}

function ne(e) {
  return R(J(U - 1, ie(91 === e ? e + 2 : 40 === e ? e + 1 : e)));
}

function re(e) {
  for (; (q = K()) && q < 33;) {
    Z();
  }

  return Q(e) > 2 || Q(q) > 3 ? "" : " ";
}

function ie(e) {
  for (; Z();) {
    switch (q) {
      case e:
        return U;

      case 34:
      case 39:
        return ie(34 === e || 39 === e ? e : q);

      case 40:
        41 === e && ie(e);
        break;

      case 92:
        Z();
    }
  }

  return U;
}

function oe(e, t) {
  for (; Z() && e + q !== 57 && (e + q !== 84 || 47 !== K());) {
    ;
  }

  return "/*" + J(t, U - 1) + "*" + I(47 === e ? e : Z());
}

function ae(e) {
  for (; !Q(K());) {
    Z();
  }

  return J(e, U);
}

function se(e) {
  return te(le("", null, null, null, [""], e = ee(e), 0, [0], e));
}

function le(e, t, n, r, i, o, a, s, l) {
  for (var c = 0, u = 0, d = a, f = 0, m = 0, p = 0, h = 1, v = 1, y = 1, g = 0, b = "", w = i, E = o, x = r, k = b; v;) {
    switch (p = g, g = Z()) {
      case 34:
      case 39:
      case 91:
      case 40:
        k += ne(g);
        break;

      case 9:
      case 10:
      case 13:
      case 32:
        k += re(p);
        break;

      case 47:
        switch (K()) {
          case 42:
          case 47:
            V(ue(oe(Z(), X()), t, n), l);
            break;

          default:
            k += "/";
        }

        break;

      case 123 * h:
        s[c++] = M(k) * y;

      case 125 * h:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            v = 0;

          case 59 + u:
            m > 0 && V(m > 32 ? de(k + ";", r, n, d - 1) : de(P(k, " ", "") + ";", r, n, d - 2), l);
            break;

          case 59:
            k += ";";

          default:
            if (V(x = ce(k, t, n, c, u, i, s, b, w = [], E = [], d), o), 123 === g) if (0 === u) le(k, t, x, x, w, o, d, s, E);else switch (f) {
              case 100:
              case 109:
              case 115:
                le(e, x, x, r && V(ce(e, x, x, 0, 0, i, s, b, i, w = [], d), E), i, E, d, s, r ? w : E);
                break;

              default:
                le(k, x, x, x, [""], E, d, s, E);
            }
        }

        c = u = m = 0, h = y = 1, b = k = "", d = a;
        break;

      case 58:
        d = 1 + M(k), m = p;

      default:
        switch (k += I(g), g * h) {
          case 38:
            y = u > 0 ? 1 : (k += "\f", -1);
            break;

          case 44:
            s[c++] = (M(k) - 1) * y, y = 1;
            break;

          case 64:
            45 === K() && (k += ne(Z())), f = K(), u = M(b = k += ae(X())), g++;
            break;

          case 45:
            45 === p && 2 == M(k) && (h = 0);
        }

    }
  }

  return o;
}

function ce(e, t, n, r, i, o, a, s, l, c, u) {
  for (var d = i - 1, f = 0 === i ? o : [""], m = H(f), p = 0, h = 0, v = 0; p < r; ++p) {
    for (var y = 0, g = j(e, d + 1, d = L(h = a[p])), b = e; y < m; ++y) {
      (b = R(h > 0 ? f[y] + " " + g : P(g, /&\f/g, f[y]))) && (l[v++] = b);
    }
  }

  return Y(e, t, n, 0 === i ? A : s, l, c, u);
}

function ue(e, t, n) {
  return Y(e, t, n, O, I(q), j(e, 2, -2), 0);
}

function de(e, t, n, r) {
  return Y(e, t, n, T, j(e, 0, r), j(e, r + 1, -1), r);
}

function fe(e, t) {
  switch (function (e, t) {
    return (((t << 2 ^ D(e, 0)) << 2 ^ D(e, 1)) << 2 ^ D(e, 2)) << 2 ^ D(e, 3);
  }(e, t)) {
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return $ + e + e;

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return $ + e + _ + e + S + e + e;

    case 6828:
    case 4268:
      return $ + e + S + e + e;

    case 6165:
      return $ + e + S + "flex-" + e + e;

    case 5187:
      return $ + e + P(e, /(\w+).+(:[^]+)/, $ + "box-$1$2" + S + "flex-$1$2") + e;

    case 5443:
      return $ + e + S + "flex-item-" + P(e, /flex-|-self/, "") + e;

    case 4675:
      return $ + e + S + "flex-line-pack" + P(e, /align-content|flex-|-self/, "") + e;

    case 5548:
      return $ + e + S + P(e, "shrink", "negative") + e;

    case 5292:
      return $ + e + S + P(e, "basis", "preferred-size") + e;

    case 6060:
      return $ + "box-" + P(e, "-grow", "") + $ + e + S + P(e, "grow", "positive") + e;

    case 4554:
      return $ + P(e, /([^-])(transform)/g, "$1" + $ + "$2") + e;

    case 6187:
      return P(P(P(e, /(zoom-|grab)/, $ + "$1"), /(image-set)/, $ + "$1"), e, "") + e;

    case 5495:
    case 3959:
      return P(e, /(image-set\([^]*)/, $ + "$1$`$1");

    case 4968:
      return P(P(e, /(.+:)(flex-)?(.*)/, $ + "box-pack:$3" + S + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $ + e + e;

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return P(e, /(.+)-inline(.+)/, $ + "$1$2") + e;

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (M(e) - 1 - t > 6) switch (D(e, t + 1)) {
        case 109:
          return P(e, /(.+:)(.+)-([^]+)/, "$1" + $ + "$2-$3$1" + _ + "$2-$3") + e;

        case 102:
          return P(e, /(.+:)(.+)-([^]+)/, "$1" + $ + "$2-$3$1" + _ + "$3") + e;

        case 115:
          return fe(P(e, "stretch", "fill-available"), t) + e;
      }
      break;

    case 4949:
      if (115 !== D(e, t + 1)) break;

    case 6444:
      switch (D(e, M(e) - 3 - (~function (e, t) {
        return e.indexOf(t);
      }(e, "!important") && 10))) {
        case 107:
        case 111:
          return P(e, e, $ + e) + e;

        case 101:
          return P(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + $ + (45 === D(e, 14) ? "inline-" : "") + "box$3$1" + $ + "$2$3$1" + S + "$2box$3") + e;
      }

      break;

    case 5936:
      switch (D(e, t + 11)) {
        case 114:
          return $ + e + S + P(e, /[svh]\w+-[tblr]{2}/, "tb") + e;

        case 108:
          return $ + e + S + P(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;

        case 45:
          return $ + e + S + P(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }

      return $ + e + S + e + e;
  }

  return e;
}

function me(e, t) {
  for (var n = "", r = H(e), i = 0; i < r; i++) {
    n += t(e[i], i, e, t) || "";
  }

  return n;
}

function pe(e, t, n, r) {
  switch (e.type) {
    case "@import":
    case T:
      return e.return = e.return || e.value;

    case O:
      return "";

    case A:
      e.value = e.props.join(",");
  }

  return M(n = me(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}

function he(e) {
  var t = H(e);
  return function (n, r, i, o) {
    for (var a = "", s = 0; s < t; s++) {
      a += e[s](n, r, i, o) || "";
    }

    return a;
  };
}

function ve(e) {
  return function (t) {
    t.root || (t = t.return) && e(t);
  };
}

var ye,
    ge,
    be = function be(e, t) {
  return te(function (e, t) {
    var n = -1,
        r = 44;

    do {
      switch (Q(r)) {
        case 0:
          38 === r && 12 === K() && (t[n] = 1), e[n] += ae(U - 1);
          break;

        case 2:
          e[n] += ne(r);
          break;

        case 4:
          if (44 === r) {
            e[++n] = 58 === K() ? "&\f" : "", t[n] = e[n].length;
            break;
          }

        default:
          e[n] += I(r);
      }
    } while (r = Z());

    return e;
  }(ee(e), t));
},
    we = new WeakMap(),
    Ee = function Ee(e) {
  if ("rule" === e.type && e.parent && e.length) {
    for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; "rule" !== n.type;) {
      n = n.parent;
    }

    if ((1 !== e.props.length || 58 === t.charCodeAt(0) || we.get(n)) && !r) {
      we.set(e, !0);

      for (var i = [], o = be(t, i), a = n.props, s = 0, l = 0; s < o.length; s++) {
        for (var c = 0; c < a.length; c++, l++) {
          e.props[l] = i[s] ? o[s].replace(/&\f/g, a[c]) : a[c] + " " + o[s];
        }
      }
    }
  }
},
    xe = function xe(e) {
  if ("decl" === e.type) {
    var t = e.value;
    108 === t.charCodeAt(0) && 98 === t.charCodeAt(2) && (e.return = "", e.value = "");
  }
},
    ke = function ke(e) {
  return 105 === e.type.charCodeAt(1) && 64 === e.type.charCodeAt(0);
},
    Ne = function Ne(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
},
    Ce = function Ce(e, t, n) {
  ke(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Ne(e)) : function (e, t) {
    for (var n = e - 1; n >= 0; n--) {
      if (!ke(t[n])) return !0;
    }

    return !1;
  }(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Ne(e)));
},
    Se = "undefined" != typeof document,
    _e = Se ? void 0 : (ye = function ye() {
  return E(function () {
    var e = {};
    return function (t) {
      return e[t];
    };
  });
}, ge = new WeakMap(), function (e) {
  if (ge.has(e)) return ge.get(e);
  var t = ye(e);
  return ge.set(e, t), t;
}),
    $e = [function (e, t, n, r) {
  if (!e.return) switch (e.type) {
    case T:
      e.return = fe(e.value, e.length);
      break;

    case "@keyframes":
      return me([G(P(e.value, "@", "@" + $), e, "")], r);

    case A:
      if (e.length) return function (e, t) {
        return e.map(t).join("");
      }(e.props, function (t) {
        switch (function (e, t) {
          return (e = t.exec(e)) ? e[0] : e;
        }(t, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return me([G(P(t, /:(read-\w+)/, ":-moz-$1"), e, "")], r);

          case "::placeholder":
            return me([G(P(t, /:(plac\w+)/, ":" + $ + "input-$1"), e, ""), G(P(t, /:(plac\w+)/, ":-moz-$1"), e, ""), G(P(t, /:(plac\w+)/, S + "input-$1"), e, "")], r);
        }

        return "";
      });
  }
}],
    Oe = function Oe(e) {
  var t = e.key;
  if ("production" !== process.env.NODE_ENV && !t) throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");

  if (Se && "css" === t) {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function (e) {
      document.head.appendChild(e), e.setAttribute("data-s", "");
    });
  }

  var r = e.stylisPlugins || $e;
  if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(t)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var i,
      o,
      a = {},
      s = [];
  Se && (i = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion]"), function (e) {
    var n = e.getAttribute("data-emotion").split(" ");

    if (n[0] === t) {
      for (var r = 1; r < n.length; r++) {
        a[n[r]] = !0;
      }

      s.push(e);
    }
  }));
  var l = [Ee, xe];

  if ("production" !== process.env.NODE_ENV && l.push(function (e) {
    return function (t, n, r) {
      if ("rule" === t.type) {
        var i,
            o = t.value.match(/(:first|:nth|:nth-last)-child/g);

        if (o && !0 !== e.compat) {
          var a = n > 0 ? r[n - 1] : null;
          if (a && function (e) {
            return !!e && "comm" === e.type && e.children.indexOf("emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason") > -1;
          }((i = a.children).length ? i[i.length - 1] : null)) return;
          o.forEach(function (e) {
            console.error('The pseudo class "' + e + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + e.split("-child")[0] + '-of-type".');
          });
        }
      }
    };
  }({
    get compat() {
      return v.compat;
    }

  }), Ce), Se) {
    var c,
        u = [pe, "production" !== process.env.NODE_ENV ? function (e) {
      e.root || (e.return ? c.insert(e.return) : e.value && e.type !== O && c.insert(e.value + "{}"));
    } : ve(function (e) {
      c.insert(e);
    })],
        d = he(l.concat(r, u));

    o = function o(e, t, n, r) {
      c = n, "production" !== process.env.NODE_ENV && void 0 !== t.map && (c = {
        insert: function insert(e) {
          n.insert(e + t.map);
        }
      }), me(se(e ? e + "{" + t.styles + "}" : t.styles), d), r && (v.inserted[t.name] = !0);
    };
  } else {
    var f = [pe],
        m = he(l.concat(r, f)),
        p = _e(r)(t),
        h = function h(e, t) {
      var n = t.name;
      return void 0 === p[n] && (p[n] = me(se(e ? e + "{" + t.styles + "}" : t.styles), m)), p[n];
    };

    o = function o(e, t, n, r) {
      var i = t.name,
          o = h(e, t);
      return void 0 === v.compat ? (r && (v.inserted[i] = !0), "development" === process.env.NODE_ENV && void 0 !== t.map ? o + t.map : o) : r ? void (v.inserted[i] = o) : o;
    };
  }

  var v = {
    key: t,
    sheet: new C({
      key: t,
      container: i,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend
    }),
    nonce: e.nonce,
    inserted: a,
    registered: {},
    insert: o
  };
  return v.sheet.hydrate(s), v;
},
    Ae = "function" == typeof Symbol && Symbol.for,
    Te = Ae ? Symbol.for("react.element") : 60103,
    Le = Ae ? Symbol.for("react.portal") : 60106,
    Ie = Ae ? Symbol.for("react.fragment") : 60107,
    Re = Ae ? Symbol.for("react.strict_mode") : 60108,
    Pe = Ae ? Symbol.for("react.profiler") : 60114,
    De = Ae ? Symbol.for("react.provider") : 60109,
    je = Ae ? Symbol.for("react.context") : 60110,
    Me = Ae ? Symbol.for("react.async_mode") : 60111,
    He = Ae ? Symbol.for("react.concurrent_mode") : 60111,
    Ve = Ae ? Symbol.for("react.forward_ref") : 60112,
    Fe = Ae ? Symbol.for("react.suspense") : 60113,
    ze = Ae ? Symbol.for("react.suspense_list") : 60120,
    We = Ae ? Symbol.for("react.memo") : 60115,
    Ue = Ae ? Symbol.for("react.lazy") : 60116,
    qe = Ae ? Symbol.for("react.block") : 60121,
    Be = Ae ? Symbol.for("react.fundamental") : 60117,
    Ye = Ae ? Symbol.for("react.responder") : 60118,
    Ge = Ae ? Symbol.for("react.scope") : 60119;

function Ze(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;

    switch (t) {
      case Te:
        switch (e = e.type) {
          case Me:
          case He:
          case Ie:
          case Pe:
          case Re:
          case Fe:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case je:
              case Ve:
              case Ue:
              case We:
              case De:
                return e;

              default:
                return t;
            }

        }

      case Le:
        return t;
    }
  }
}

function Ke(e) {
  return Ze(e) === He;
}

var Xe = {
  AsyncMode: Me,
  ConcurrentMode: He,
  ContextConsumer: je,
  ContextProvider: De,
  Element: Te,
  ForwardRef: Ve,
  Fragment: Ie,
  Lazy: Ue,
  Memo: We,
  Portal: Le,
  Profiler: Pe,
  StrictMode: Re,
  Suspense: Fe,
  isAsyncMode: function isAsyncMode(e) {
    return Ke(e) || Ze(e) === Me;
  },
  isConcurrentMode: Ke,
  isContextConsumer: function isContextConsumer(e) {
    return Ze(e) === je;
  },
  isContextProvider: function isContextProvider(e) {
    return Ze(e) === De;
  },
  isElement: function isElement(e) {
    return "object" == typeof e && null !== e && e.$$typeof === Te;
  },
  isForwardRef: function isForwardRef(e) {
    return Ze(e) === Ve;
  },
  isFragment: function isFragment(e) {
    return Ze(e) === Ie;
  },
  isLazy: function isLazy(e) {
    return Ze(e) === Ue;
  },
  isMemo: function isMemo(e) {
    return Ze(e) === We;
  },
  isPortal: function isPortal(e) {
    return Ze(e) === Le;
  },
  isProfiler: function isProfiler(e) {
    return Ze(e) === Pe;
  },
  isStrictMode: function isStrictMode(e) {
    return Ze(e) === Re;
  },
  isSuspense: function isSuspense(e) {
    return Ze(e) === Fe;
  },
  isValidElementType: function isValidElementType(e) {
    return "string" == typeof e || "function" == typeof e || e === Ie || e === He || e === Pe || e === Re || e === Fe || e === ze || "object" == typeof e && null !== e && (e.$$typeof === Ue || e.$$typeof === We || e.$$typeof === De || e.$$typeof === je || e.$$typeof === Ve || e.$$typeof === Be || e.$$typeof === Ye || e.$$typeof === Ge || e.$$typeof === qe);
  },
  typeOf: Ze
},
    Je = p(function (e, t) {
  "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
        n = e ? Symbol.for("react.element") : 60103,
        r = e ? Symbol.for("react.portal") : 60106,
        i = e ? Symbol.for("react.fragment") : 60107,
        o = e ? Symbol.for("react.strict_mode") : 60108,
        a = e ? Symbol.for("react.profiler") : 60114,
        s = e ? Symbol.for("react.provider") : 60109,
        l = e ? Symbol.for("react.context") : 60110,
        c = e ? Symbol.for("react.async_mode") : 60111,
        u = e ? Symbol.for("react.concurrent_mode") : 60111,
        d = e ? Symbol.for("react.forward_ref") : 60112,
        f = e ? Symbol.for("react.suspense") : 60113,
        m = e ? Symbol.for("react.suspense_list") : 60120,
        p = e ? Symbol.for("react.memo") : 60115,
        h = e ? Symbol.for("react.lazy") : 60116,
        v = e ? Symbol.for("react.block") : 60121,
        y = e ? Symbol.for("react.fundamental") : 60117,
        g = e ? Symbol.for("react.responder") : 60118,
        b = e ? Symbol.for("react.scope") : 60119;

    function w(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case n:
            var m = e.type;

            switch (m) {
              case c:
              case u:
              case i:
              case a:
              case o:
              case f:
                return m;

              default:
                var v = m && m.$$typeof;

                switch (v) {
                  case l:
                  case d:
                  case h:
                  case p:
                  case s:
                    return v;

                  default:
                    return t;
                }

            }

          case r:
            return t;
        }
      }
    }

    var E = c,
        x = u,
        k = l,
        N = s,
        C = n,
        S = d,
        _ = i,
        $ = h,
        O = p,
        A = r,
        T = a,
        L = o,
        I = f,
        R = !1;

    function P(e) {
      return w(e) === u;
    }

    t.AsyncMode = E, t.ConcurrentMode = x, t.ContextConsumer = k, t.ContextProvider = N, t.Element = C, t.ForwardRef = S, t.Fragment = _, t.Lazy = $, t.Memo = O, t.Portal = A, t.Profiler = T, t.StrictMode = L, t.Suspense = I, t.isAsyncMode = function (e) {
      return R || (R = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), P(e) || w(e) === c;
    }, t.isConcurrentMode = P, t.isContextConsumer = function (e) {
      return w(e) === l;
    }, t.isContextProvider = function (e) {
      return w(e) === s;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, t.isForwardRef = function (e) {
      return w(e) === d;
    }, t.isFragment = function (e) {
      return w(e) === i;
    }, t.isLazy = function (e) {
      return w(e) === h;
    }, t.isMemo = function (e) {
      return w(e) === p;
    }, t.isPortal = function (e) {
      return w(e) === r;
    }, t.isProfiler = function (e) {
      return w(e) === a;
    }, t.isStrictMode = function (e) {
      return w(e) === o;
    }, t.isSuspense = function (e) {
      return w(e) === f;
    }, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === i || e === u || e === a || e === o || e === f || e === m || "object" == typeof e && null !== e && (e.$$typeof === h || e.$$typeof === p || e.$$typeof === s || e.$$typeof === l || e.$$typeof === d || e.$$typeof === y || e.$$typeof === g || e.$$typeof === b || e.$$typeof === v);
    }, t.typeOf = w;
  }();
}),
    Qe = p(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = Xe : e.exports = Je;
}),
    et = {};
et[Qe.ForwardRef] = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, et[Qe.Memo] = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
};
var tt = "undefined" != typeof document;

function nt(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function (n) {
    void 0 !== e[n] ? t.push(e[n] + ";") : r += n + " ";
  }), r;
}

var rt = function rt(e, t, n) {
  var r = e.key + "-" + t.name;

  if ((!1 === n || !1 === tt && void 0 !== e.compat) && void 0 === e.registered[r] && (e.registered[r] = t.styles), void 0 === e.inserted[t.name]) {
    var i = "",
        o = t;

    do {
      var a = e.insert(t === o ? "." + r : "", o, e.sheet, !0);
      tt || void 0 === a || (i += a), o = o.next;
    } while (void 0 !== o);

    if (!tt && 0 !== i.length) return i;
  }
};

var it = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
},
    ot = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    at = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).",
    st = /[A-Z]|^ms/g,
    lt = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
    ct = function ct(e) {
  return 45 === e.charCodeAt(1);
},
    ut = function ut(e) {
  return null != e && "boolean" != typeof e;
},
    dt = E(function (e) {
  return ct(e) ? e : e.replace(st, "-$&").toLowerCase();
}),
    ft = function ft(e, t) {
  switch (e) {
    case "animation":
    case "animationName":
      if ("string" == typeof t) return t.replace(lt, function (e, t, n) {
        return Et = {
          name: t,
          styles: n,
          next: Et
        }, t;
      });
  }

  return 1 === it[e] || ct(e) || "number" != typeof t || 0 === t ? t : t + "px";
};

if ("production" !== process.env.NODE_ENV) {
  var mt = /(attr|calc|counters?|url)\(/,
      pt = ["normal", "none", "counter", "open-quote", "close-quote", "no-open-quote", "no-close-quote", "initial", "inherit", "unset"],
      ht = ft,
      vt = /^-ms-/,
      yt = /-(.)/g,
      gt = {};

  ft = function ft(e, t) {
    if ("content" === e && ("string" != typeof t || -1 === pt.indexOf(t) && !mt.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || '"' !== t.charAt(0) && "'" !== t.charAt(0)))) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var n = ht(e, t);
    return "" === n || ct(e) || -1 === e.indexOf("-") || void 0 !== gt[e] || (gt[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(vt, "ms-").replace(yt, function (e, t) {
      return t.toUpperCase();
    }) + "?")), n;
  };
}

function bt(e, t, n) {
  if (null == n) return "";

  if (void 0 !== n.__emotion_styles) {
    if ("production" !== process.env.NODE_ENV && "NO_COMPONENT_SELECTOR" === n.toString()) throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");
    return n;
  }

  switch (typeof n) {
    case "boolean":
      return "";

    case "object":
      if (1 === n.anim) return Et = {
        name: n.name,
        styles: n.styles,
        next: Et
      }, n.name;

      if (void 0 !== n.styles) {
        var r = n.next;
        if (void 0 !== r) for (; void 0 !== r;) {
          Et = {
            name: r.name,
            styles: r.styles,
            next: Et
          }, r = r.next;
        }
        var i = n.styles + ";";
        return "production" !== process.env.NODE_ENV && void 0 !== n.map && (i += n.map), i;
      }

      return function (e, t, n) {
        var r = "";
        if (Array.isArray(n)) for (var i = 0; i < n.length; i++) {
          r += bt(e, t, n[i]) + ";";
        } else for (var o in n) {
          var a = n[o];
          if ("object" != typeof a) null != t && void 0 !== t[a] ? r += o + "{" + t[a] + "}" : ut(a) && (r += dt(o) + ":" + ft(o, a) + ";");else {
            if ("NO_COMPONENT_SELECTOR" === o && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");

            if (!Array.isArray(a) || "string" != typeof a[0] || null != t && void 0 !== t[a[0]]) {
              var s = bt(e, t, a);

              switch (o) {
                case "animation":
                case "animationName":
                  r += dt(o) + ":" + s + ";";
                  break;

                default:
                  "production" !== process.env.NODE_ENV && "undefined" === o && console.error(at), r += o + "{" + s + "}";
              }
            } else for (var l = 0; l < a.length; l++) {
              ut(a[l]) && (r += dt(o) + ":" + ft(o, a[l]) + ";");
            }
          }
        }
        return r;
      }(e, t, n);

    case "function":
      if (void 0 !== e) {
        var o = Et,
            a = n(e);
        return Et = o, bt(e, t, a);
      }

      "production" !== process.env.NODE_ENV && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;

    case "string":
      if ("production" !== process.env.NODE_ENV) {
        var s = [],
            l = n.replace(lt, function (e, t, n) {
          var r = "animation" + s.length;
          return s.push("const " + r + " = keyframes`" + n.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + r + "}";
        });
        s.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(s, ["`" + l + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\ncss`" + l + "`");
      }

  }

  if (null == t) return n;
  var c = t[n];
  return void 0 !== c ? c : n;
}

var wt,
    Et,
    xt = /label:\s*([^\s;\n{]+)\s*;/g;
"production" !== process.env.NODE_ENV && (wt = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);

var kt = function kt(e, t, n) {
  if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
  var r = !0,
      i = "";
  Et = void 0;
  var o,
      a = e[0];
  null == a || void 0 === a.raw ? (r = !1, i += bt(n, t, a)) : ("production" !== process.env.NODE_ENV && void 0 === a[0] && console.error(ot), i += a[0]);

  for (var s = 1; s < e.length; s++) {
    i += bt(n, t, e[s]), r && ("production" !== process.env.NODE_ENV && void 0 === a[s] && console.error(ot), i += a[s]);
  }

  "production" !== process.env.NODE_ENV && (i = i.replace(wt, function (e) {
    return o = e, "";
  })), xt.lastIndex = 0;

  for (var l, c = ""; null !== (l = xt.exec(i));) {
    c += "-" + l[1];
  }

  var u = function (e) {
    for (var t, n = 0, r = 0, i = e.length; i >= 4; ++r, i -= 4) {
      t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(r) | (255 & e.charCodeAt(++r)) << 8 | (255 & e.charCodeAt(++r)) << 16 | (255 & e.charCodeAt(++r)) << 24)) + (59797 * (t >>> 16) << 16), n = 1540483477 * (65535 & (t ^= t >>> 24)) + (59797 * (t >>> 16) << 16) ^ 1540483477 * (65535 & n) + (59797 * (n >>> 16) << 16);
    }

    switch (i) {
      case 3:
        n ^= (255 & e.charCodeAt(r + 2)) << 16;

      case 2:
        n ^= (255 & e.charCodeAt(r + 1)) << 8;

      case 1:
        n = 1540483477 * (65535 & (n ^= 255 & e.charCodeAt(r))) + (59797 * (n >>> 16) << 16);
    }

    return (((n = 1540483477 * (65535 & (n ^= n >>> 13)) + (59797 * (n >>> 16) << 16)) ^ n >>> 15) >>> 0).toString(36);
  }(i) + c;

  return "production" !== process.env.NODE_ENV ? {
    name: u,
    styles: i,
    map: o,
    next: Et,
    toString: function toString() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: u,
    styles: i,
    next: Et
  };
},
    Nt = "undefined" != typeof document,
    Ct = Object.prototype.hasOwnProperty,
    St = a("undefined" != typeof HTMLElement ? Oe({
  key: "css"
}) : null),
    _t = (St.Provider, function (e) {
  return i(function (t, n) {
    var r = o(St);
    return e(t, r, n);
  });
});

Nt || (_t = function _t(e) {
  return function (t) {
    var n = o(St);
    return null === n ? (n = Oe({
      key: "css"
    }), s(St.Provider, {
      value: n
    }, e(t, n))) : e(t, n);
  };
});

var $t = a({}),
    Ot = _t(function (e, t, n) {
  var r = e.css;
  "string" == typeof r && void 0 !== t.registered[r] && (r = t.registered[r]);
  var i = e.__EMOTION_TYPE_PLEASE_DO_NOT_USE__,
      a = [r],
      c = "";
  "string" == typeof e.className ? c = nt(t.registered, a, e.className) : null != e.className && (c = e.className + " ");
  var u = kt(a, void 0, "function" == typeof r || Array.isArray(r) ? o($t) : void 0);

  if ("production" !== process.env.NODE_ENV && -1 === u.name.indexOf("-")) {
    var d = e.__EMOTION_LABEL_PLEASE_DO_NOT_USE__;
    d && (u = kt([u, "label:" + d + ";"]));
  }

  var f = rt(t, u, "string" == typeof i);
  c += t.key + "-" + u.name;
  var m = {};

  for (var p in e) {
    !Ct.call(e, p) || "css" === p || "__EMOTION_TYPE_PLEASE_DO_NOT_USE__" === p || "production" !== process.env.NODE_ENV && "__EMOTION_LABEL_PLEASE_DO_NOT_USE__" === p || (m[p] = e[p]);
  }

  m.ref = n, m.className = c;
  var h = s(i, m);

  if (!Nt && void 0 !== f) {
    for (var v, y = u.name, g = u.next; void 0 !== g;) {
      y += " " + g.name, g = g.next;
    }

    return s(l, null, s("style", ((v = {})["data-emotion"] = t.key + " " + y, v.dangerouslySetInnerHTML = {
      __html: f
    }, v.nonce = t.sheet.nonce, v)), h);
  }

  return h;
});

"production" !== process.env.NODE_ENV && (Ot.displayName = "EmotionCssPropInternal");

function At() {
  for (var e = arguments, t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
    n[r] = e[r];
  }

  return kt(n);
}

var Tt = function Tt() {
  var e = At.apply(void 0, arguments),
      t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

if ("production" !== process.env.NODE_ENV) {
  var Lt = "undefined" != typeof document,
      It = "undefined" != typeof jest;

  if (Lt && !It) {
    var Rt = Lt ? window : global,
        Pt = "__EMOTION_REACT_" + "11.1.1".split(".")[0] + "__";
    Rt[Pt] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), Rt[Pt] = !0;
  }
}

var Dt = k,
    jt = function jt(e) {
  return "theme" !== e;
},
    Mt = function Mt(e) {
  return "string" == typeof e && e.charCodeAt(0) > 96 ? Dt : jt;
},
    Ht = function Ht(e, t, n) {
  var r;

  if (t) {
    var i = t.shouldForwardProp;
    r = e.__emotion_forwardProp && i ? function (t) {
      return e.__emotion_forwardProp(t) && i(t);
    } : i;
  }

  return "function" != typeof r && n && (r = e.__emotion_forwardProp), r;
},
    Vt = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    Ft = "undefined" != typeof document,
    zt = function e(t, n) {
  if ("production" !== process.env.NODE_ENV && void 0 === t) throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
  var r,
      i,
      a = t.__emotion_real === t,
      c = a && t.__emotion_base || t;
  void 0 !== n && (r = n.label, i = n.target);
  var u = Ht(t, n, a),
      d = u || Mt(c),
      f = !d("as");
  return function () {
    var m = arguments,
        p = a && void 0 !== t.__emotion_styles ? t.__emotion_styles.slice(0) : [];
    if (void 0 !== r && p.push("label:" + r + ";"), null == m[0] || void 0 === m[0].raw) p.push.apply(p, m);else {
      "production" !== process.env.NODE_ENV && void 0 === m[0][0] && console.error(Vt), p.push(m[0][0]);

      for (var h = m.length, v = 1; v < h; v++) {
        "production" !== process.env.NODE_ENV && void 0 === m[0][v] && console.error(Vt), p.push(m[v], m[0][v]);
      }
    }

    var y = _t(function (e, t, n) {
      var r = f && e.as || c,
          a = "",
          m = [],
          h = e;

      if (null == e.theme) {
        for (var v in h = {}, e) {
          h[v] = e[v];
        }

        h.theme = o($t);
      }

      "string" == typeof e.className ? a = nt(t.registered, m, e.className) : null != e.className && (a = e.className + " ");
      var y = kt(p.concat(m), t.registered, h),
          g = rt(t, y, "string" == typeof r);
      a += t.key + "-" + y.name, void 0 !== i && (a += " " + i);
      var b = f && void 0 === u ? Mt(r) : d,
          w = {};

      for (var E in e) {
        f && "as" === E || b(E) && (w[E] = e[E]);
      }

      w.className = a, w.ref = n;
      var x = s(r, w);

      if (!Ft && void 0 !== g) {
        for (var k, N = y.name, C = y.next; void 0 !== C;) {
          N += " " + C.name, C = C.next;
        }

        return s(l, null, s("style", ((k = {})["data-emotion"] = t.key + " " + N, k.dangerouslySetInnerHTML = {
          __html: g
        }, k.nonce = t.sheet.nonce, k)), x);
      }

      return x;
    });

    return y.displayName = void 0 !== r ? r : "Styled(" + ("string" == typeof c ? c : c.displayName || c.name || "Component") + ")", y.defaultProps = t.defaultProps, y.__emotion_real = y, y.__emotion_base = c, y.__emotion_styles = p, y.__emotion_forwardProp = u, Object.defineProperty(y, "toString", {
      value: function value() {
        return void 0 === i && "production" !== process.env.NODE_ENV ? "NO_COMPONENT_SELECTOR" : "." + i;
      }
    }), y.withComponent = function (t, r) {
      return e(t, N({}, n, {}, r, {
        shouldForwardProp: Ht(y, r, !0)
      })).apply(void 0, p);
    }, y;
  };
}.bind();

["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"].forEach(function (e) {
  zt[e] = zt(e);
});
var Wt = zt.ul(_templateObject()),
    Ut = zt.li(_templateObject2(), function (e) {
  return e.disable ? "pointer-events: none; filter: opacity(0.7)" : "";
}),
    qt = zt.button(_templateObject3(), function (e) {
  return e.theme.primary;
}, function (e) {
  if ("TRUE" === e.rotate) return "rotate(90deg)";
}, function (e) {
  return "TRUE" === e.rotate ? "rotate(90deg)" : "";
}),
    Bt = zt.div(_templateObject4(), function (e) {
  return e.slideShowActive ? "hidden" : "visible";
}),
    Yt = zt.button(_templateObject5(), function (e) {
  return e.theme.primary;
}),
    Gt = (zt(Yt)(_templateObject6()), zt(Yt)(_templateObject7()), t.memo(function (e) {
  var n = e.onNext,
      i = e.onPrevious,
      o = e.onFirst,
      a = e.onLast,
      s = e.disableLeft,
      l = e.disableRight,
      c = e.theme,
      u = e.slideShowRunning,
      d = e.onReplay,
      f = e.slideShowEnabled,
      m = e.mode,
      p = r(function () {
    return "HORIZONTAL" !== m;
  }, [m]);
  return t.createElement(Bt, {
    slideShowActive: u
  }, t.createElement(Wt, {
    className: "timeline-controls"
  }, t.createElement(Ut, {
    disable: s
  }, t.createElement(qt, {
    mode: m,
    theme: c,
    onClick: o,
    title: "Go to First",
    "aria-label": "first",
    "aria-disabled": s,
    "aria-controls": "timeline-main-wrapper",
    tabIndex: s ? -1 : 0,
    rotate: p ? "TRUE" : "FALSE"
  }, t.createElement(g, null))), t.createElement(Ut, {
    disable: s
  }, t.createElement(qt, {
    mode: m,
    theme: c,
    onClick: i,
    title: "Previous",
    "aria-label": "previous",
    "aria-disabled": s,
    "aria-controls": "timeline-main-wrapper",
    tabIndex: s ? -1 : 0,
    rotate: p ? "TRUE" : "FALSE"
  }, t.createElement(v, null))), t.createElement(Ut, {
    disable: l
  }, t.createElement(qt, {
    mode: m,
    theme: c,
    onClick: n,
    title: "Next",
    "aria-label": "next",
    "aria-disabled": l,
    "aria-controls": "timeline-main-wrapper",
    rotate: p ? "TRUE" : "FALSE",
    tabIndex: l ? -1 : 0
  }, t.createElement(y, null))), t.createElement(Ut, {
    disable: l
  }, t.createElement(qt, {
    mode: m,
    theme: c,
    onClick: a,
    title: "Go to Last",
    "aria-label": "last",
    "aria-disabled": l,
    "aria-controls": "timeline-main-wrapper",
    tabIndex: l ? -1 : 0,
    rotate: p ? "TRUE" : "FALSE"
  }, t.createElement(b, null))), t.createElement(Ut, null, f && t.createElement(qt, {
    theme: c,
    onClick: d,
    title: "Play Slideshow",
    tabIndex: 0,
    "aria-controls": "timeline-main-wrapper",
    "aria-label": "Play Slideshow"
  }, t.createElement(w, null)))));
}));
Gt.displayName = "Timeline Control";
var Zt = p(function (e) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  !function () {
    var t = {}.hasOwnProperty;

    function n() {
      for (var e = arguments, r = [], i = 0; i < arguments.length; i++) {
        var o = e[i];

        if (o) {
          var a = typeof o;
          if ("string" === a || "number" === a) r.push(o);else if (Array.isArray(o) && o.length) {
            var s = n.apply(null, o);
            s && r.push(s);
          } else if ("object" === a) for (var l in o) {
            t.call(o, l) && o[l] && r.push(l);
          }
        }
      }

      return r.join(" ");
    }

    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  }();
}),
    Kt = zt.section(_templateObject8(), function (e) {
  return e.theme.cardBgColor;
}, function (e) {
  return "VERTICAL_ALTERNATING" !== e.mode ? "1em 0" : "";
}, function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}),
    Xt = zt.header(_templateObject9()),
    Jt = zt.p(_templateObject10(), function (e) {
  return e.theme.primary;
}),
    Qt = zt.p(_templateObject11(), function (e) {
  return e.theme.cardForeColor;
}, function (e) {
  return e.theme.primary;
}),
    en = zt.p(_templateObject12(), function (e) {
  return e.theme.cardForeColor;
}),
    tn = zt.div(_templateObject13(), function (e) {
  return e.customContent ? "" : "max-height: 200px;";
}, function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}),
    nn = zt.span(_templateObject14(), function (e) {
  return e.show ? "flex" : "none";
}, function (e) {
  return e.theme.primary;
}),
    rn = zt.span(_templateObject15(), function (e) {
  return e.color;
}, function (e) {
  return !e.paused && e.startWidth && e.startWidth > 0 ? At(_templateObject16(), (t = e.startWidth, n = 0, Tt(_templateObject17(), t, n)), e.duration) : At(_templateObject18(), e.startWidth);
  var t, n;
}),
    on = zt.span(_templateObject19(), function (e) {
  return e.collapsed ? "\n      transform: rotate(90deg);\n  " : "transform: rotate(-90deg)";
}),
    an = t.memo(function (e) {
  var n = e.title,
      r = e.theme,
      i = e.color,
      o = e.dir,
      a = e.active;
  return n && r ? t.createElement(Qt, {
    className: a ? "active card-title" : "card-title",
    theme: r,
    style: {
      color: i
    },
    dir: o
  }, n) : null;
}, function () {
  return !0;
});
an.displayName = "Timeline Title";
var sn = t.memo(function (e) {
  var n = e.content,
      r = e.color,
      i = e.dir,
      o = e.theme;
  return n ? t.createElement(Jt, {
    style: {
      color: r
    },
    dir: i,
    theme: o,
    className: "card-sub-title"
  }, n) : null;
}, function () {
  return !0;
});
sn.displayName = "Timeline Content";

var ln = zt.div(_templateObject20(), function (e) {
  return e.cardHeight ? "min-height: ".concat(e.cardHeight, "px;") : "";
}, function (e) {
  var t;
  return e.active ? "rgba(".concat(null === (t = e.theme) || void 0 === t ? void 0 : t.secondary, ", 0.35)") : "";
}, function (e) {
  return !e.active && e.slideShowActive ? "none" : "";
}, function (e) {
  return "HORIZONTAL" === e.mode || "left" === e.dir ? "\n        justify-content: flex-start;\n      " : "\n        justify-content: flex-end;\n      ";
}),
    cn = zt.img(_templateObject21(), function (e) {
  return e.visible ? "visible" : "hidden";
}),
    un = zt.video(_templateObject22()),
    dn = zt.div(_templateObject23(), function (e) {
  switch (e.mode) {
    case "HORIZONTAL":
    case "VERTICAL":
    case "VERTICAL_ALTERNATING":
      return "100%";
  }
}),
    fn = zt.span(_templateObject24()),
    mn = function mn(e) {
  var i = e.active,
      o = e.id,
      a = e.mode,
      s = e.onMediaStateChange,
      l = e.theme,
      f = e.title,
      m = e.content,
      p = e.media,
      h = e.slideshowActive,
      v = e.hideMedia;
  void 0 === v && (v = !1);
  var y = e.cardHeight,
      g = c(null),
      b = n(!1),
      w = b[0],
      E = b[1];
  u(function () {
    g && (i ? g.current && g.current.play() : g.current && g.current.pause());
  }, [i]);

  var x = n(!1),
      k = x[0],
      N = x[1],
      C = d(function () {
    N(!0);
  }, []),
      S = d(function () {
    E(!0), s({
      id: o,
      paused: !1,
      playing: !1
    });
  }, []),
      _ = t.memo(function (e) {
    var n = e.message;
    return t.createElement(fn, null, n);
  }),
      $ = r(function () {
    return t.createElement(un, {
      controls: !0,
      autoPlay: i,
      ref: g,
      onLoadedData: C,
      onPlay: function onPlay() {
        return s({
          id: o,
          paused: !1,
          playing: !0
        });
      },
      onPause: function onPause() {
        return s({
          id: o,
          paused: !0,
          playing: !1
        });
      },
      onEnded: function onEnded() {
        return s({
          id: o,
          paused: !1,
          playing: !1
        });
      },
      onError: S
    }, t.createElement("source", {
      src: p.source.url
    }));
  }, [i]),
      O = r(function () {
    return t.createElement(cn, {
      src: p.source.url,
      mode: a,
      onLoad: C,
      onError: S,
      visible: k,
      active: i,
      alt: p.name
    });
  }, [i, k]);

  return _.displayName = "Error Message", t.createElement(t.Fragment, null, t.createElement(ln, {
    theme: l,
    active: i,
    mode: a,
    slideShowActive: h,
    className: "card-media-wrapper",
    cardHeight: y
  }, "VIDEO" === p.type && (w ? t.createElement(_, {
    message: "Failed to load the video"
  }) : $), "IMAGE" === p.type && (w ? t.createElement(_, {
    message: "Failed to load the image."
  }) : O)), t.createElement(dn, {
    mode: a
  }, t.createElement(an, {
    title: f,
    theme: l,
    active: i
  }), t.createElement(sn, {
    content: m
  })));
},
    pn = t.memo(function (e) {
  var i = e.active,
      o = e.cardHeight,
      a = e.content,
      s = e.detailedText,
      l = e.id,
      f = e.media,
      m = e.mode,
      p = e.onShowMore,
      h = e.slideShowActive,
      v = e.slideItemDuration,
      g = e.onElapsed,
      b = e.theme,
      w = e.title,
      E = e.onClick,
      x = e.customContent,
      k = e.hasFocus,
      N = n(!1),
      C = N[0],
      S = N[1],
      _ = c(null),
      $ = c(null),
      O = c(null),
      A = c(0),
      T = c(0),
      L = c(0),
      I = c(),
      R = n(!1),
      P = R[0],
      D = R[1],
      j = n(0),
      M = j[0],
      H = j[1],
      V = n(0),
      F = V[0],
      z = V[1],
      W = r(function () {
    var e = i && h;
    return f ? e && "VIDEO" !== f.type : e;
  }, [i, h]),
      U = r(function () {
    return !!s;
  }, [s]);

  u(function () {
    var e = _.current;
    e && (e.scrollTop = 0);
  }, [C]), u(function () {
    setTimeout(function () {
      $.current && (A.current = $.current.clientWidth, z(A.current));
    }, 100);
  }, []);
  var q = d(function (e) {
    v && (H(e), I.current = new Date(), D(!1), L.current = window.setTimeout(function () {
      window.clearTimeout(L.current), D(!0), z(0), H(v), l && g && g(l);
    }, e));
  }, []),
      B = d(function () {
    if (i && h) {
      if (window.clearTimeout(L.current), D(!0), I.current) {
        var e = +new Date() - +I.current;
        T.current = e;
      }

      O.current && z(O.current.clientWidth);
    }
  }, [i, h]),
      Y = d(function () {
    if (i && h) {
      if (!v) return;
      var e = v - T.current;
      D(!1), e > 0 && q(e);
    }
  }, [i, h, v]);
  u(function () {
    v && (i && h && (z(A.current), q(v)), i && k && $.current && $.current.focus());
  }, [i, h]), u(function () {
    k && i && $.current && $.current.focus();
  }, [k, i]);
  var G = d(function (e) {
    h && (e.playing ? B() : e.paused && P && l && g && g(l));
  }, [P, h]),
      Z = r(function () {
    return Zt(i ? "timeline-card-content active" : "timeline-card-content ");
  }, [i]),
      K = r(function () {
    return Zt(C || x ? "card-description" : "show-less card-description");
  }, [C, x]),
      X = d(function () {
    (i && P || !h) && (S(!C), p());
  }, [i, P, h, C]);
  return t.createElement(Kt, {
    className: Z,
    theme: b,
    noMedia: !f,
    minHeight: o,
    mode: m,
    onClick: function onClick(e) {
      e.stopPropagation(), !h && E && l && E(l);
    },
    onMouseEnter: B,
    onMouseLeave: Y,
    ref: $,
    tabIndex: 0
  }, t.createElement(Xt, null, !f && t.createElement(an, {
    title: w,
    theme: b
  }), !f && t.createElement(sn, {
    content: a,
    theme: b
  })), f && t.createElement(mn, {
    media: f,
    content: a,
    title: w,
    mode: m,
    onMediaStateChange: G,
    id: l,
    active: i,
    theme: b,
    slideshowActive: h,
    hideMedia: C,
    cardHeight: o
  }), t.createElement(tn, {
    ref: _,
    className: K,
    theme: b,
    "aria-expanded": C,
    customContent: !!x
  }, x ? t.createElement(t.Fragment, null, x) : t.createElement(en, {
    className: C ? "active" : "",
    ref: _,
    theme: b
  }, s)), s && !x && t.createElement(nn, {
    role: "button",
    onClick: X,
    onKeyPress: d(function (e) {
      "Enter" === e.key && X();
    }, [i, P, h, C]),
    className: "show-more",
    show: U,
    theme: b,
    tabIndex: 0
  }, t.createElement("span", null, C ? "read less" : "read more"), t.createElement(on, {
    collapsed: !C
  }, t.createElement(y, null))), W && t.createElement(rn, {
    startWidth: F,
    paused: P,
    duration: M,
    ref: O,
    color: b && b.primary
  }));
});

pn.displayName = "TimelineCardContent";

var hn = zt.div(_templateObject25(), function (e) {
  return e.hide ? "hidden" : "visible";
}, function (e) {
  return e.align;
}, function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.secondary;
}, function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}),
    vn = function vn(e) {
  var n = e.title,
      i = e.active,
      o = e.theme,
      a = e.align,
      s = r(function () {
    return Zt("timeline-item-title", i ? "active" : "");
  }, [i]);
  return t.createElement(hn, {
    className: s,
    theme: o,
    hide: !n,
    align: a
  }, n);
},
    yn = zt.div(_templateObject26()),
    gn = (zt.div(_templateObject27()), Tt(_templateObject28())),
    bn = Tt(_templateObject29()),
    wn = Tt(_templateObject30()),
    En = zt.div(_templateObject31()),
    xn = zt.div(_templateObject32(), function (e) {
  var t;
  return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, gn, function (e) {
  return e.theme.secondary;
}, bn),
    kn = zt.div(_templateObject33()),
    Nn = zt.div(_templateObject34(), wn),
    Cn = function Cn(e) {
  var n = e.active,
      i = e.autoScroll,
      o = e.cardHeight,
      a = e.cardDetailedText,
      s = e.cardSubtitle,
      l = e.cardTitle,
      f = e.id,
      p = e.media,
      h = e.mode,
      v = e.onClick,
      y = e.onElapsed,
      g = e.position,
      b = e.slideItemDuration,
      w = e.slideShowRunning,
      E = e.theme,
      x = e.title,
      k = e.wrapperId,
      N = e.customContent,
      C = e.hasFocus,
      S = c(null),
      _ = c(null),
      $ = c(null);

  u(function () {
    if (n) {
      var e = S.current,
          t = _.current;

      if (e && t) {
        var r = e.offsetLeft,
            o = t.offsetLeft;
        i({
          timelinePointOffset: r + o,
          timelinePointWidth: e.clientWidth
        });
      }
    }
  }, [n, i, h]);
  var O = d(function () {}, []),
      A = r(function () {
    return null == h ? void 0 : h.toLowerCase();
  }, [h]),
      T = r(function () {
    return Zt("timeline-horz-card-wrapper", A, "top" === g ? "bottom" : "top");
  }, [h, g]),
      L = r(function () {
    return Zt(A, g);
  }, []),
      I = r(function () {
    return Zt("timeline-circle", A, n ? "active" : "in-active");
  }, [n]),
      R = r(function () {
    return t.createElement(Nn, {
      className: T,
      ref: $
    }, t.createElement(pn, {
      content: s,
      active: n,
      title: l,
      detailedText: a,
      onShowMore: O,
      theme: E,
      slideShowActive: w,
      media: p,
      mode: h,
      cardHeight: o,
      slideItemDuration: b,
      onElapsed: y,
      id: f,
      customContent: N,
      hasFocus: C
    }));
  }, [n]);
  return t.createElement(yn, {
    ref: _,
    className: A,
    "data-testid": "timeline-item"
  }, n && function () {
    var e = document.getElementById(k);
    if (e) return m.createPortal(R, e);
  }(), t.createElement(En, null, t.createElement(xn, {
    className: I,
    onClick: function onClick() {
      v && !w && v(f);
    },
    ref: S,
    "data-testid": "timeline-circle",
    theme: E,
    "aria-label": x
  })), t.createElement(kn, {
    className: L,
    "data-testid": "timeline-title"
  }, t.createElement(vn, {
    title: x,
    active: n,
    theme: E
  })));
},
    Sn = zt.ul(_templateObject35()),
    _n = zt.li(_templateObject36(), function (e) {
  return e.width;
}),
    $n = function $n(e) {
  var n = e.items,
      i = e.itemWidth,
      o = e.handleItemClick,
      a = e.autoScroll,
      s = e.mode,
      l = e.wrapperId,
      c = e.theme,
      u = e.slideShowRunning,
      d = e.cardHeight,
      f = e.slideItemDuration,
      m = e.onElapsed,
      p = e.contentDetailsChildren,
      h = e.hasFocus,
      v = r(function () {
    return Zt(s.toLowerCase(), "timeline-horz-container");
  }, [s]);
  return t.createElement(Sn, {
    className: v,
    "data-testid": "timeline-collection"
  }, n.map(function (e, n) {
    return t.createElement(_n, {
      key: e.id,
      width: i,
      className: Zt(e.visible ? "visible" : "", "timeline-horz-item-container")
    }, t.createElement(Cn, Object.assign({}, e, {
      onClick: o,
      autoScroll: a,
      mode: s,
      wrapperId: l,
      theme: c,
      slideShowRunning: u,
      cardHeight: d,
      slideItemDuration: f,
      onElapsed: m,
      customContent: p ? p[n] : null,
      hasFocus: h
    })));
  }));
},
    On = zt.div(_templateObject37()),
    An = Tt(_templateObject38()),
    Tn = zt.div(_templateObject39()),
    Ln = zt.div(_templateObject40(), function (e) {
  return e.bg;
}),
    In = zt.div(_templateObject41(), function (e) {
  return e.alternateCards ? "width: 50%;" : e.noTitle ? "width: 90%;" : "width: 75%;";
}, function (e) {
  return e.flip ? "\n        &.left {\n          order: 3;\n        }\n        &.right {\n          order: 1;\n        }\n      " : "\n        &.left {\n          order: 1;\n        }\n        &.right {\n          order: 3;\n        }\n      ";
}, An),
    Rn = zt.div(_templateObject42()),
    Pn = zt.div(_templateObject43(), function (e) {
  return e.hide && "VERTICAL" === e.mode ? "none" : "flex";
}, function (e) {
  return e.alternateCards ? "width: 50%" : "width: 15%";
}, function (e) {
  return e.flip ? "flex-end" : "flex-start";
}, function (e) {
  return e.flip && "VERTICAL_ALTERNATING" === e.mode ? "1" : "3";
}, function (e) {
  return e.flip ? "\n      order: 3;\n      justify-content: flex-start;" : "order: 1;\n    justify-content: flex-end;";
}),
    Dn = function Dn(e) {
  var n = e.className,
      r = e.id,
      i = e.onClick,
      o = e.active,
      a = e.onActive,
      s = e.theme,
      l = e.alternateCards,
      d = e.slideShowRunning,
      f = c(null);
  return u(function () {
    if (o) {
      var e = f.current;
      e && a(e.offsetTop);
    }
  }, [o]), t.createElement(Ln, {
    className: n,
    "data-testid": "tree-leaf",
    bg: s && s.primary,
    alternateCards: l,
    role: "button"
  }, t.createElement(Rn, {
    className: "".concat(n, " timeline-vertical-circle"),
    onClick: function onClick(e) {
      e.stopPropagation(), r && i && !d && i(r);
    },
    ref: f,
    role: "button",
    "data-testid": "tree-leaf-click",
    "aria-label": "select timeline"
  }, t.createElement(xn, {
    className: o ? "active" : "in-active",
    theme: s
  })));
},
    jn = function jn(e) {
  var n = c(null),
      i = e.active,
      o = e.alternateCards,
      a = e.cardDetailedText,
      s = e.cardHeight,
      l = e.cardSubtitle,
      u = e.cardTitle,
      f = e.className,
      m = e.contentDetailsChildren,
      p = e.hasFocus,
      h = e.id,
      v = e.index,
      y = e.media,
      g = e.mode,
      b = e.onActive,
      w = e.onClick,
      E = e.onElapsed,
      x = e.slideItemDuration,
      k = e.slideShowRunning,
      N = e.theme,
      C = e.title,
      S = e.visible,
      _ = e.flipLayout,
      $ = function $(e) {
    if (n.current) {
      var t = n.current,
          r = t.offsetTop,
          i = t.clientHeight;
      b(r + e, r, i);
    }
  },
      O = d(function () {
    setTimeout(function () {
      $(0);
    }, 100);
  }, []),
      A = r(function () {
    return t.createElement(Pn, {
      className: f,
      alternateCards: o,
      mode: g,
      hide: !C,
      flip: _
    }, t.createElement(vn, {
      title: C,
      active: i,
      theme: N,
      align: _ ? "left" : "right"
    }));
  }, [i]),
      T = r(function () {
    var e;
    return Zt(((e = {})[f] = !0, e), "vertical-item-row", S ? "visible" : "");
  }, []),
      L = r(function () {
    var e,
        n = Zt("card-content-wrapper", S ? "visible" : "", ((e = {})[f] = !0, e));
    return t.createElement(In, {
      className: n,
      alternateCards: o,
      noTitle: !C,
      flip: _
    }, t.createElement(pn, {
      active: i,
      branchDir: f,
      cardHeight: s,
      content: l,
      customContent: m,
      detailedText: a,
      hasFocus: p,
      id: h,
      media: y,
      mode: g,
      onClick: w,
      onElapsed: E,
      onShowMore: O,
      slideItemDuration: x,
      slideShowActive: k,
      theme: N,
      title: u
    }));
  }, [p, k, i]),
      I = r(function () {
    return t.createElement(Dn, {
      active: i,
      alternateCards: o,
      className: f,
      id: h,
      mode: g,
      onActive: $,
      onClick: w,
      slideShowRunning: k,
      theme: N
    });
  }, [k, i]);

  return t.createElement(Tn, {
    alternateCards: o,
    cardHeight: s,
    className: T,
    "data-testid": "vertical-item-row",
    key: v,
    ref: n,
    role: "listitem"
  }, A, L, I);
},
    Mn = function Mn(e) {
  var n = e.items,
      r = e.onClick,
      i = e.autoScroll,
      o = e.theme,
      a = e.alternateCards;
  void 0 === a && (a = !0);
  var s = e.slideShowRunning,
      l = e.mode,
      c = e.cardHeight,
      u = e.slideItemDuration,
      f = e.onElapsed,
      m = e.contentDetailsChildren,
      p = e.hasFocus,
      h = e.flipLayout,
      v = d(function (e, t, n) {
    i({
      timelinePointOffset: e,
      timelineContentHeight: n,
      timelineContentOffset: t
    });
  }, []),
      y = d(function () {}, []);
  return t.createElement(On, {
    "data-testid": "tree-main",
    role: "list"
  }, n.map(function (e, n) {
    var i = "";
    i = a && n % 2 == 0 ? "left" : "right";
    var d = m && m[n] || null;
    return t.createElement(jn, Object.assign({}, e, {
      className: i,
      index: n,
      key: e.id,
      theme: o,
      alternateCards: a,
      slideShowRunning: s,
      mode: l,
      cardHeight: c,
      slideItemDuration: u,
      onShowMore: y,
      onActive: v,
      onClick: r,
      onElapsed: f,
      contentDetailsChildren: d,
      hasFocus: p,
      flipLayout: h
    }));
  }));
},
    Hn = zt.div(_templateObject44(), function (e) {
  return "TOP" === e.cardPositionHorizontal ? "\n    & > div:nth-of-type(1) {\n      order: 2;\n    }\n    & > div:nth-of-type(2) {\n      order: 1; \n    }\n    & > div:nth-of-type(3) {\n      order: 3;\n    }\n  " : "";
}),
    Vn = zt.div(_templateObject45(), function (e) {
  return e.scrollable ? "auto" : "hidden";
}, function (e) {
  return e.theme.primary;
}, function (e) {
  if (e.scrollable) return e.scrollable instanceof Boolean && e.scrollable || e.scrollable.scrollbar ? "" : "0 1rem 0";
}, function (e) {
  return e.theme.primary;
}, function (e) {
  return e.theme.primary;
}),
    Fn = zt.div(_templateObject46()),
    zn = zt.div(_templateObject47(), function (e) {
  return e.color;
}),
    Wn = zt.div(_templateObject48(), function (e) {
  return e.active ? "opacity(1);" : "opacity(0.9);";
}),
    Un = zt.div(_templateObject49()),
    qn = function qn(i) {
  var o = i.activeTimelineItem,
      a = i.disableNavOnKey,
      s = i.itemWidth;
  void 0 === s && (s = 200);
  var l = i.items;
  void 0 === l && (l = []);
  var m = i.mode;
  void 0 === m && (m = "HORIZONTAL");

  var p = i.onNext,
      v = i.onPrevious,
      y = i.onTimelineUpdated,
      g = i.slideShowRunning,
      b = i.onLast,
      w = i.onFirst,
      E = i.theme,
      x = i.onRestartSlideshow,
      k = i.cardHeight,
      N = i.slideShowEnabled,
      C = i.slideItemDuration,
      S = i.hideControls,
      _ = i.scrollable,
      $ = i.cardPositionHorizontal,
      O = i.contentDetailsChildren,
      A = i.flipLayout,
      T = h(m, s),
      L = T[0],
      I = T[1],
      R = c(null),
      P = n(!1),
      D = P[0],
      j = P[1],
      M = c(null),
      H = r(function () {
    if (!g) return _;
  }, [g, _]),
      V = c(e()),
      F = function F() {
    return D && p();
  },
      z = function z() {
    return D && v();
  },
      W = function W() {
    return D && w();
  },
      U = function U() {
    return D && b();
  },
      q = function q(e, t) {
    if (e) for (var n = 0; n < l.length; n++) {
      if (l[n].id === e) {
        t && n < l.length - 1 ? y(n + 1) : y(n);
        break;
      }
    }
  },
      B = d(function (e) {
    var t = M.current;
    t && I(t, e);
  }, [I]);

  return u(function () {
    var e = M.current;
    e && ("HORIZONTAL" === m ? e.scrollLeft = L : e.scrollTop = L);
  }, [L]), f(function () {
    return setTimeout(function () {
      var e = M.current;

      if (e) {
        var t = e.querySelectorAll(".vertical-item-row");
        Array.from(t).forEach(function (e) {
          R.current && R.current.observe(e);
        });
      }
    }, 0), "HORIZONTAL" !== m && (R.current = new IntersectionObserver(function (e) {
      var t = function t(e) {
        return e.style.visibility = "hidden";
      },
          n = function n(e) {
        return e.style.visibility = "visible";
      };

      e.forEach(function (e) {
        var r = e.target;
        e.isIntersecting ? (r.querySelectorAll("img").forEach(n), r.querySelectorAll("video").forEach(n)) : (r.querySelectorAll("img").forEach(t), r.querySelectorAll("video").forEach(t));
      });
    }, {
      root: M.current,
      threshold: 0
    })), function () {
      R.current && R.current.disconnect();
    };
  }, []), t.createElement(Hn, {
    onKeyDown: function onKeyDown(e) {
      return a || g ? null : (t = e.key, void ("HORIZONTAL" === m && "ArrowRight" === t || ("VERTICAL" === m || "VERTICAL_ALTERNATING" === m) && "ArrowDown" === t ? F() : "HORIZONTAL" === m && "ArrowLeft" === t || ("VERTICAL" === m || "VERTICAL_ALTERNATING" === m) && "ArrowUp" === t ? z() : "Home" === t ? W() : "End" === t && U()));
      var t;
    },
    className: "".concat(m.toLowerCase(), " js-focus-visible focus-visible"),
    cardPositionHorizontal: $,
    onClickCapture: function onClickCapture() {
      j(!0);
    }
  }, t.createElement(Vn, {
    ref: M,
    scrollable: H,
    className: "".concat(m.toLowerCase(), " timeline-main-wrapper"),
    id: "timeline-main-wrapper",
    theme: E
  }, "VERTICAL_ALTERNATING" === m ? t.createElement(Mn, {
    activeTimelineItem: o,
    autoScroll: B,
    cardHeight: k,
    contentDetailsChildren: O,
    hasFocus: D,
    items: l,
    mode: m,
    onClick: q,
    onElapsed: function onElapsed(e) {
      return q(e, !0);
    },
    slideItemDuration: C,
    slideShowRunning: g,
    theme: E,
    flipLayout: A
  }) : null, "HORIZONTAL" === m ? t.createElement(Fn, {
    className: m.toLowerCase()
  }, t.createElement(zn, {
    color: E && E.primary
  }), t.createElement($n, {
    autoScroll: B,
    cardHeight: k,
    contentDetailsChildren: O,
    handleItemClick: q,
    hasFocus: D,
    itemWidth: s,
    items: l,
    mode: m,
    onElapsed: function onElapsed(e) {
      return q(e, !0);
    },
    slideItemDuration: C,
    slideShowRunning: g,
    theme: E,
    wrapperId: V.current
  })) : null, "VERTICAL" === m ? t.createElement(Mn, {
    activeTimelineItem: o,
    alternateCards: !1,
    autoScroll: B,
    cardHeight: k,
    contentDetailsChildren: O,
    hasFocus: D,
    items: l,
    mode: m,
    onClick: q,
    onElapsed: function onElapsed(e) {
      return q(e, !0);
    },
    slideItemDuration: C,
    slideShowRunning: g,
    theme: E,
    flipLayout: A
  }) : null), !S && t.createElement(Wn, {
    mode: m
  }, t.createElement(Gt, {
    onNext: F,
    onPrevious: z,
    onFirst: W,
    onLast: U,
    disableLeft: 0 === o,
    disableRight: o === l.length - 1,
    mode: m,
    theme: E,
    onReplay: x,
    slideShowRunning: g,
    slideShowEnabled: N,
    id: V.current
  })), t.createElement(Un, {
    id: V.current
  }));
},
    Bn = function Bn(r) {
  var i = r.items,
      o = r.itemWidth;
  void 0 === o && (o = 300);
  var a = r.mode;
  void 0 === a && (a = "HORIZONTAL");
  var s = r.disableNavOnKey;
  void 0 === s && (s = !1);
  var l = r.slideShow;
  void 0 === l && (l = !1);
  var f = r.slideItemDuration;
  void 0 === f && (f = 5e3);
  var m = r.theme,
      p = r.cardHeight;
  void 0 === p && (p = 200);
  var h = r.hideControls;
  void 0 === h && (h = !1);
  var v = r.scrollable;
  void 0 === v && (v = !0);
  var y = r.cardPositionHorizontal;
  void 0 === y && (y = "BOTTOM");

  var g = r.children,
      b = r.flipLayout,
      w = n([]),
      E = w[0],
      x = w[1],
      k = c(),
      N = n(!1),
      C = N[0],
      S = N[1],
      _ = n(0),
      $ = _[0],
      O = _[1],
      A = Object.assign({
    primary: "#0f52ba",
    secondary: "#ffdf00",
    cardBgColor: "#fff",
    cardForeColor: "#000"
  }, m),
      T = function T() {
    return i && i.length ? i.map(function (t, n) {
      return Object.assign({}, t, {
        id: e(),
        visible: !0,
        active: 0 === n
      });
    }) : Array.from({
      length: g.length
    }).map(function (t, n) {
      return {
        id: e(),
        visible: !0,
        active: 0 === n
      };
    });
  };

  u(function () {
    var e = T();
    k.current = e, x(e);
  }, []);
  var L = d(function (e) {
    x(function (t) {
      return t.map(function (t, n) {
        return Object.assign({}, t, {
          active: n === e
        });
      });
    }), O(e), i && i.length - 1 === e && S(!1);
  }, []),
      I = d(function () {
    S(!0), L(0);
  }, []);
  return t.createElement(qn, {
    activeTimelineItem: $,
    cardHeight: p,
    cardPositionHorizontal: y,
    contentDetailsChildren: g,
    disableNavOnKey: s,
    hideControls: h,
    itemWidth: o,
    items: E,
    mode: a,
    onFirst: function onFirst() {
      O(0), L(0);
    },
    onLast: function onLast() {
      if (E.length) {
        var e = E.length - 1;
        O(e), L(e);
      }
    },
    onNext: function onNext() {
      if (E.length && $ < E.length - 1) {
        var e = $ + 1;
        L(e), O(e);
      }
    },
    onPrevious: function onPrevious() {
      if ($ > 0) {
        var e = $ - 1;
        L(e), O(e);
      }
    },
    onRestartSlideshow: I,
    onTimelineUpdated: d(L, []),
    scrollable: v,
    slideItemDuration: f,
    slideShow: l,
    slideShowEnabled: l,
    slideShowRunning: C,
    theme: A,
    flipLayout: b
  });
};

export { Bn as Chrono };